if (!customElements.get("video-media")) {
  customElements.define(
    "video-media",
    class VideoMedia extends HTMLElement {
      constructor() {
        super();
        this.video = this.querySelector("video");
        this.playToggle = this.querySelector(".js-play-toggle");
        this.audioToggle = this.querySelector(".js-audio-toggle");
        //console.log(this.audioToggle)
        this.started = false;

        this.lazyLoadObserve();
        this.bindEvents();
      }

      bindEvents() {
        this.playToggle?.addEventListener("click", this.togglePlay.bind(this));
        this.audioToggle?.addEventListener("click", this.toggleAudio.bind(this));
      }

      togglePlay() {
        if (this.video.paused) {
          this.playToggle.classList.add('active')
          this.video.play();
        } else {
          this.playToggle.classList.remove('active')
          this.video.pause();
        }
      }

      toggleAudio() {
        if (this.video.muted) {
          this.audioToggle.classList.add('active')
          this.video.muted = false;
        } else {
          this.audioToggle.classList.remove('active')
          this.video.muted = true;
        }
      }

      lazyLoadObserve() {
        if ("IntersectionObserver" in window) {
          let lazyVideoObserver = new IntersectionObserver(function (
            entries,
            observer
          ) {
            entries.forEach(function (video) {
              if (video.isIntersecting) {
                for (var source in video.target.children) {
                  let videoSource = video.target.children[source];
                  if (
                    typeof videoSource.tagName === "string" &&
                    videoSource.tagName === "SOURCE"
                  ) {
                    videoSource.src = videoSource.dataset.src;
                  }
                }
                video.target.load();
                video.target
                  .play()
                  .then(() => {
                    //terrible mobile object-fit hack
                    setTimeout(() => {
                      video.target.classList.remove("loading");
                    }, 500);
                  })
                  .catch((error) => {
                    //terrible low powermode hack
                    //console.log("Video Error Detected");
                  });

                lazyVideoObserver.unobserve(video.target);
              }
            });
          });
          lazyVideoObserver.observe(this.video);
        }
      }
    }
  );
}
